<template>
  <div>
    <div
      class="p-6"
      v-if="!checking_subs"
    >
      <div class="p-6">
        <label>Show:</label>
        <button
          type="button"
          class="p-3 py-2 rounded"
          :class="{'bg-brand text-white': interval == 'monthly', 'border border-brand text-brand': interval != 'monthly'}"
          @click.prevent="interval = 'monthly'"
        >Monthly</button>
        <button
          type="button"
          class="p-3 py-2 rounded"
          :class="{'bg-brand text-white': interval == 'yearly', 'border border-brand text-brand': interval != 'yearly'}"
          @click.prevent="interval = 'yearly'"
        >Yearly</button>
      </div>
      <div
        class="flex justify-center flex-wrap"
        v-if="authorized"
      >
        <plan
          v-for="subscription, subscription_type in plans"
          :key="subscription_type"
          :interval="interval"
          :subscription="subscription"
          :subscription-type="subscription_type"
          :current-subscription="current_subscription"
          @select-plan="selectPlan"
        ></plan>
      </div>

      <div
        class="bg-orange-lightest text-orange-dark p-4 text-center w-full"
        role="alert"
        v-else
      >
        <p>Unable to change plan because you do not have any subscriptions or you are unauthorized.</p>
      </div>
    </div>

    <div
      v-else
      class="w-full h-screen flex flex-col justify-center items-center"
    >
      <i class="fa fa-circle-notch fa-spin fa-3x"></i>
      <p class="mt-4">Please wait...</p>
    </div>

    <sweet-modal
      icon="error"
      ref="change_plan_error"
      overlay-theme="dark"
    >
      <p class="font-medium">An Error Occured</p>
      <p class="mt-4">{{last_error}}</p>
    </sweet-modal>

    <sweet-modal
      icon="success"
      ref="change_plan_success"
      overlay-theme="dark"
    >
      <p class="mt-4">Your Plan has been updated</p>
    </sweet-modal>

    <sweet-modal
      ref="changing_plan"
      overlay-theme="dark"
      hide-close-button
    >
      <div class="flex flex-col overflow-hidden">
        <i class="fa fa-spin fa-circle-o-notch fa-3x"></i>
        <p class="mt-4">Changing your plan, please wait.</p>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Plan from "../../components/Plan";

export default {
  components: {
    Plan
  },

  data () {
    return {
      current_subscription: {},
      last_error: {},
      authorized: false,
      checking_subs: true,
      interval: "monthly"
    };
  },

  mounted () {
    this.getCurrentSubscription();
  },

  methods: {
    getCurrentSubscription () {
      axios.get("api/users/subscriptions").then(({ data }) => {
        this.checking_subs = false;
        let vault_id = this.$route.params.vault_id;

        this.current_subscription = _.find(data, function (subscription) {
          if(subscription.vault && subscription.vault.id) {
            return subscription.vault.id == vault_id;
          }
        });

        if (!_.isEmpty(this.current_subscription)) {
          this.authorized = true;
        }
      });
    },

    selectPlan (id) {
      this.$refs.changing_plan.open();
      axios
        .patch(`api/users/subscriptions/${this.current_subscription.id}/plan`, {
          plan_id: id
        })
        .then(({ data }) => {
          this.$refs.changing_plan.close();
          this.$refs.change_plan_success.open();
          this.getCurrentSubscription();
        })
        .catch(error => {
          this.$refs.changing_plan.close();
          let data = error.response.data;

          if (data.message && data.success != undefined) {
            this.last_error = data.message;
          } else {
            this.last_error = "";
          }
          this.$refs.change_plan_error.open();
        });
    },
    convert ($megabytes) {
      return Math.floor($megabytes / 1024);
    }
  },

  computed: {
    ...mapGetters({
      plans: "getPlans"
    })
  }
};
</script>

<style>
</style>
